<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      size="small"
    >
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item
            label="Carrier (for Customer)"
            prop="carrierId"
            :rules="[
              { required: true, message: 'Please enter and select a carrier', trigger: 'blur' }
            ]"
          >
            <CarrierAutoComplete
              ref="carrierList"
              v-model="form.carrier"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Zone">
            <ZonesForm
              ref="zoneList"
              v-model="form.zoneId"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col>
        <el-button
          type="primary"
          size="small"
          class="float-right"
          @click.native="downloadCSV"
        >
          Generate Report
        </el-button>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Freight Zones Report"
      :is-show.sync="isShowPreview"
      :is-direct-download="true"
      :configuration="configuration"
    />
  </div>
</template>

<script>
import ZonesForm from '@/components/Application/Reports/ZonesForm'
import CarrierAutoComplete from '@/components/Application/Reports/CarrierAutoComplete'
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    ZonesForm,
    CarrierAutoComplete,
    Preview
  },
  data () {
    return {
      form: {
        carrier: {},
        carrierId: null,
        zoneFromName: ''
      },
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    downloadCSV () {
      if (this.form.carrier) {
        this.form.carrierId = this.$refs.carrierList.getCarrierId()
      }
      if (this.$refs.zoneList.getName()) {
        this.form.zoneFromName = this.$refs.zoneList.getName()
      } else {
        this.form.zoneFromName = ''
      }
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.configuration = {
            report: 'ZonesEtaReport',
            params: this.form
          }
          this.isShowPreview = true
        }
      })
    }
  }
}
</script>
